// @flow

export const config = (
    state: {} = {},
    action: { type: string, config: {} }
): {} => {
    switch (action.type) {
        default:
            return state;
    }
};
